/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import MultiLineTextItemEdit from "./edit-item";

const MultiLineFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <MultiLineTextItemEdit />
        </FieldListEditWrapper>
    );
};
MultiLineFieldEdit.displayName = "MultiLineFieldEdit";
export { MultiLineFieldEdit };
